export const UrlUtils = {

  obterUrlCompleta: caminhoRelativo => process.env.VUE_APP_BASE_IMAGENS_URL + caminhoRelativo,
  obterUrlS3: caminhoRelativo => process.env.VUE_APP_BASE_IMAGENS_URL + caminhoRelativo

}

export default UrlUtils
